/**
 * Compact loading state component for Public Recording
 * Uses pulsing dots for consistent "system working" visual language
 */

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { motion } from 'framer-motion';

import { PulsingDots } from './PulsingDots';

export const CompactLoadingState = () => {
  return (
    <motion.div
      key="loading"
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      style={{ maxHeight: '48px' }}
      className="relative w-full h-full flex items-center justify-center px-3">
      <div className="relative z-10 flex items-center max-w-7xl">
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <button
              className="flex items-center justify-center cursor-help focus:outline-none pointer-events-auto"
              type="button"
              aria-label="Loading status">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-100 to-blue-100 dark:from-purple-900/30 dark:to-blue-900/30 flex items-center justify-center border-2 border-purple-200 dark:border-purple-800 pointer-events-none">
                <PulsingDots size={5} />
              </motion.div>
            </button>
          </TooltipTrigger>
          <TooltipContent
            side="left"
            sideOffset={8}
            avoidCollisions={false}
            className="z-50">
            <p>Connecting...</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </motion.div>
  );
};
